module.exports = __webpack_public_path__ + "static/media/gopay-checklist.8d2e34de.svg";